import { Pipe, PipeTransform, NgModule } from '@angular/core';

@Pipe({ name: 'initials' })
export class InitialsPipe implements PipeTransform {
    constructor() { }
    transform(value) {
        if (value) {
            let fragments = value.split(' ');
            let initals = '';
            fragments.forEach((fr) => {
                if (fr)
                    initals += fr[0].toUpperCase();
            });
            return initals.substring(0, 2);
        }
        return null;
    }
}

@NgModule({
    declarations: [InitialsPipe],
    exports: [InitialsPipe]
})
export class InitialsPipeModule {
}